// @flow

import {
  type IncomingOneStepData,
  type OverwrittenPaymentTypesTitles,
} from './types';
import { type Country } from '@tectonics/prs/country';

export function getOverwrittenPaymentTypesTitles(incomingOneStepData: IncomingOneStepData): ?OverwrittenPaymentTypesTitles {
  return incomingOneStepData['overwritten_payment_types_titles'];
}

export type GetOverwrittenPaymentTypeTitleArgs = {|
  titles: OverwrittenPaymentTypesTitles,
  paymentMethodCode: string,
  countryCode: Country,
  defaultTitle: string,
|};

export function getOverwrittenPaymentTypeTitle({
  titles,
  paymentMethodCode,
  countryCode,
  defaultTitle,
}: GetOverwrittenPaymentTypeTitleArgs): string {
  if (!titles) {
    return defaultTitle;
  }
  const keys = Object.keys(titles);
  const countryBasedKey = `${paymentMethodCode}_${countryCode}`;
  if (keys.includes(countryBasedKey)) {
    return titles[countryBasedKey];
  }
  if (keys.includes(paymentMethodCode)) {
    return titles[paymentMethodCode];
  }
  return defaultTitle;
}
